/**
 * @license @tabler/icons-vue v3.29.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconDiaper = createVueComponent("outline", "diaper", "IconDiaper", [["path", { "d": "M3 8.323c0 -.579 0 -.868 .044 -1.11a2.7 2.7 0 0 1 2.17 -2.169c.239 -.044 .529 -.044 1.109 -.044h11.353c.579 0 .868 0 1.11 .044a2.7 2.7 0 0 1 2.169 2.17c.044 .24 .044 .53 .044 1.11v2.676a9 9 0 0 1 -18 0z", "key": "svg-0" }], ["path", { "d": "M17 9h4", "key": "svg-1" }], ["path", { "d": "M3 9h4", "key": "svg-2" }], ["path", { "d": "M14.25 19.7v-1.4a6.3 6.3 0 0 1 6.3 -6.3", "key": "svg-3" }], ["path", { "d": "M9.75 19.7v-1.4a6.3 6.3 0 0 0 -6.3 -6.3", "key": "svg-4" }]]);

export { IconDiaper as default };
//# sourceMappingURL=IconDiaper.mjs.map
